import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUser, hasTrussAnalysisPermission } from './users';

export const shouldUserSeeReleaseNotes = createSelector(
  [getLoggedInUser, hasTrussAnalysisPermission],

  (user, hasTrussAnalysis) => user && hasTrussAnalysis,
);
